/* cache-bust redeploy 2026-09-13T05:50Z */
class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.cart-drawer__inner') || this.querySelector('.cart-drawer__header-close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }
    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  syncRenderedCartState() {
    const hasItems = !!this.querySelector('#CartDrawer-CartItems .cart-drawer__body-item');
    const inner = this.querySelector('.cart-drawer__inner');
    const checkout = this.querySelector('#CartDrawer-Checkout');

    this.classList.toggle('is-empty', !hasItems);

    if (inner) {
      inner.classList.toggle('cart-drawer__inner--empty', !hasItems);
      inner.classList.toggle('is-empty', !hasItems);
    }

    if (checkout) checkout.disabled = !hasItems;
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    this.syncRenderedCartState();

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [{ id: 'cart-drawer', selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) { this.activeElement = element; }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__inner' },
      { id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);

/* IDRAK Systems commerce controller — rev 2026-09-13 (integrity fix)
   Primary System-lock enforcement now lives in server-rendered Liquid
   (snippets/cart-drawer.liquid, sections/main-cart-items.liquid): every
   cart render already comes out of Shopify with quantity/remove controls
   suppressed on complete System instances and with normal controls on
   everything else, including a broken (1-of-3 or 2-of-3) System instance.
   That is what makes native Dawn cart mutations (CartItems.updateQuantity,
   CartDrawer.renderContents) safe by construction: whatever fresh section
   HTML they swap in is already correctly locked, with no "hide it after
   the fact" step and therefore no reappearance window.
   What is left for this controller, as a secondary guard:
     1) composing and adding a System to the cart (unchanged composition
        logic — do not alter which products/positions a System contains);
     2) handling the "Remove system" action (multi-line removal Dawn's
        native single-line remove button can't express);
     3) detecting a System instance that is no longer complete (e.g. one
        component was removed in Shopify Checkout) and normalizing its
        surviving line(s) back to plain standalone lines — this needs a
        cart WRITE, which Liquid cannot do, so it must happen here;
     4) keeping the drawer/cart-page/icon-bubble in sync with the
        authoritative cart on load, on checkout return (pageshow), and
        after any cart mutation, per Requirement B/G. */
(function(){
  if(window.__idrakSystemsCommerceV1) return;
  window.__idrakSystemsCommerceV1=true;
  var rootPath=function(){return (window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';};
  var url=function(p){return rootPath()+p.replace(/^\//,'');};
  var timer=null;
  function slug(v){return String(v||'idrak-system').toLowerCase().replace(/™/g,'').replace(/&/g,'and').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')||'idrak-system';}
  function numeric(v){var n=parseInt(String(v||'').split('/').pop(),10);return Number.isFinite(n)&&n>0?n:null;}
  function instance(name){return slug(name)+'-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,8);}
  function textTarget(btn){return btn.querySelector('[data-idrak-btn-text]')||btn;}
  function busy(btn,on,label){if(!btn.dataset.idrakOriginalText)btn.dataset.idrakOriginalText=textTarget(btn).textContent.trim();btn.disabled=!!on;btn.setAttribute('aria-busy',on?'true':'false');textTarget(btn).textContent=label||btn.dataset.idrakOriginalText;}
  function status(btn){var r=btn.closest('[data-idrak-purchase-shell]');if(r)return r.querySelector('[data-idrak-add-status]');r=btn.closest('[data-nf2-system]');return r?r.querySelector('[data-nf2-system-status]'):null;}
  function fromSystemPage(btn){
    var r=btn.closest('[data-idrak-purchase-shell]'),script=r&&r.querySelector('[data-idrak-items]');if(!r||!script)return null;
    var src;try{src=JSON.parse(script.textContent||'[]');}catch(e){return null;}
    var name=r.dataset.idrakSystem||(src[0]&&src[0].properties&&src[0].properties._idrak_system)||'IDRAK System',key=slug(name),inst=instance(name);
    var items=src.map(function(x,i){var id=numeric(x.id);return id?{id:id,quantity:1,properties:Object.assign({},x.properties||{},{_idrak_system:name,_idrak_system_key:key,_idrak_system_instance:inst,_idrak_system_position:String(i+1),_idrak_system_origin:'system-page'})}:null;}).filter(Boolean);
    return items.length===3?{name:name,instance:inst,items:items}:null;
  }
  function fromPdp(btn){
    var r=btn.closest('[data-nf2-system]');if(!r)return null;
    var raw=(r.querySelector('.nf2-system__offer small')||{}).textContent||'Executive Performance System';
    var name=/executive/i.test(raw)?'Executive Performance System':raw.trim(),key=slug(name),inst=instance(name);
    var items=Array.from(r.querySelectorAll('[data-nf2-system-variant]')).map(function(el,i){var id=numeric(el.dataset.variantId);return id?{id:id,quantity:1,properties:{_idrak_system:name,_idrak_system_key:key,_idrak_system_instance:inst,_idrak_system_position:String(i+1),_idrak_system_origin:'pdp-system'}}:null;}).filter(Boolean);
    return items.length===3?{name:name,instance:inst,items:items}:null;
  }
  function makeSystem(btn){return btn.matches('[data-idrak-add]')?fromSystemPage(btn):fromPdp(btn);}
  function openDrawer(data){var d=document.querySelector('cart-drawer');if(d&&typeof d.renderContents==='function'&&data&&data.sections){d.renderContents(data);setTimeout(schedule,120);return true;}return false;}
  function add(btn,sys){
    var s=status(btn),orig=textTarget(btn).textContent.trim();btn.dataset.idrakOriginalText=orig;busy(btn,true,'Adding system…');if(s)s.textContent='Adding '+sys.name+' to your cart.';
    fetch(url('/cart/add.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:sys.items,sections:['cart-drawer','cart-icon-bubble'],sections_url:location.pathname})})
      .then(function(r){if(!r.ok)return r.text().then(function(t){throw new Error(t||'Unable to add system');});return r.json();})
      .then(function(data){busy(btn,false,orig);if(s)s.textContent=sys.name+' added. Review your cart or continue shopping.';if(!openDrawer(data))location.href=url('/cart');})
      .catch(function(){busy(btn,false,orig);if(s)s.textContent='The system could not be added. Please try again.';});
  }
  function props(item){return item&&item.properties?item.properties:{};}
  function keyOf(item){var p=props(item);return p._idrak_system_instance?String(p._idrak_system_instance):(p._idrak_system?'legacy:'+slug(p._idrak_system):'');}
  function removeSystem(inst,main){fetch(url('/cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(cart){var updates={};(cart.items||[]).forEach(function(i){if(keyOf(i)===inst)updates[i.key]=0;});if(!Object.keys(updates).length)return null;var body={updates:updates};if(!main){body.sections=['cart-drawer','cart-icon-bubble'];body.sections_url=location.pathname;}return fetch(url('/cart/update.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});}).then(function(r){if(!r)return null;if(!r.ok)throw new Error();return r.json();}).then(function(data){if(!data)return;if(main){location.reload();return;}if(!openDrawer(data))location.href=url('/cart');}).catch(function(){});}

  /* --- Requirement C: broken-instance detection ---
     Group by _idrak_system_instance; an instance is complete only when
     positions 1, 2 and 3 are each present exactly once (mere presence of
     _idrak_system is not sufficient — mirrors the Liquid-side check). */
  function buildInstanceGroups(items){
    var m=new Map();
    items.forEach(function(item,i){
      var p=props(item),inst=p._idrak_system_instance;
      if(!inst)return;
      if(!m.has(inst))m.set(inst,{key:inst,name:p._idrak_system||'IDRAK System',items:[],positions:{}});
      var g=m.get(inst);
      g.items.push({item:item,index:i});
      var pos=p._idrak_system_position;
      if(pos)g.positions[pos]=(g.positions[pos]||0)+1;
    });
    m.forEach(function(g){g.complete=g.items.length===3&&g.positions['1']===1&&g.positions['2']===1&&g.positions['3']===1;});
    return m;
  }

  /* --- Requirements D/E: storefront recovery ---
     For every line in a broken instance, strip only the _idrak_system*
     properties (via a full /cart/change.js properties replacement — the
     Ajax Cart API has no partial-property-delete call) and keep variant,
     quantity, selling plan and any unrelated property untouched. Never
     changes quantity, never removes the line, never re-adds the missing
     component. Each _idrak_system* key is explicitly set to null (not
     omitted): Shopify's /cart/change.js treats an empty properties:{}
     payload as a no-op, so a line whose properties are idrak-only must
     still send a non-empty payload for the strip to actually take
     effect. */
  function normalizeBrokenInstances(cart){
    var groups=buildInstanceGroups(cart.items||[]),toFix=[];
    groups.forEach(function(g){if(!g.complete)g.items.forEach(function(e){toFix.push(e);});});
    if(!toFix.length)return Promise.resolve(false);
    var chain=Promise.resolve();
    toFix.forEach(function(entry){
      chain=chain.then(function(){
        var p=props(entry.item),stripped={};
        Object.keys(p).forEach(function(k){stripped[k]=(k.indexOf('_idrak_system')===0)?null:p[k];});
        return fetch(url('/cart/change.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:entry.index+1,quantity:entry.item.quantity,properties:stripped})});
      });
    });
    return chain.then(function(){return true;}).catch(function(){return false;});
  }

  function syncCartIconBubble(cart){
    var live=document.getElementById('cart-icon-bubble');
    if(!live)return;
    var count=cart.item_count;
    var customCount=live.querySelector('.ihd-count');
    var dawnCount=live.querySelector('.cart-count-bubble span[aria-hidden="true"]');
    if(customCount){
      if(count>0){
        if(customCount.textContent!==String(count))customCount.textContent=String(count);
      } else {
        customCount.remove();
      }
    }
    if(dawnCount&&dawnCount.textContent.trim()!==String(count)){dawnCount.textContent=String(count);}
    var label='Cart'+(count>0?(', '+count+(count===1?' item':' items')):'');
    if(live.getAttribute('aria-label')!==label)live.setAttribute('aria-label',label);
  }

  /* Defensive cross-region resync only (no re-decorating): the fetched
     section HTML already comes out of Liquid correctly locked/grouped, so
     swapping it in is sufficient — this just covers a mutation made via
     one region (e.g. the /cart page) while the other region (the
     background drawer) is still showing what it had at page load. */
  function resyncTbody(sectionId,tbodySelector){
    var liveTbody=document.querySelector(tbodySelector);
    if(!liveTbody)return Promise.resolve();
    return fetch(url('/cart?section_id='+sectionId),{credentials:'same-origin'})
      .then(function(r){return r.ok?r.text():null;})
      .then(function(html){
        if(!html)return;
        var doc=new DOMParser().parseFromString(html,'text/html');
        var freshTbody=doc.querySelector(tbodySelector);
        if(freshTbody&&liveTbody.innerHTML!==freshTbody.innerHTML){liveTbody.innerHTML=freshTbody.innerHTML;}
      })
      .catch(function(){});
  }

  /* Requirement C/D/G core loop: read authoritative cart state, fix any
     broken instance found, report whether anything changed. */
  function reconcileOnce(){
    return fetch(url('/cart.js'),{credentials:'same-origin',headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        syncCartIconBubble(cart);
        return normalizeBrokenInstances(cart);
      });
  }

  function refreshRegions(){
    return Promise.all([
      resyncTbody('cart-drawer','#CartDrawer-CartItems tbody'),
      resyncTbody('main-cart-items','#main-cart-items tbody')
    ]);
  }

  function schedule(){
    clearTimeout(timer);
    timer=setTimeout(function(){
      refreshRegions().catch(function(){});
      reconcileOnce().catch(function(){});
    },80);
  }

  /* Requirement G: checkout return. On pageshow (covers both a bfcache
     restore from the browser Back button and a fresh reload), always
     re-check the authoritative cart first. If a System instance broke in
     Checkout, normalize it, then reload once so every surface — line
     items, counts, checkout total, discount display, System grouping —
     is rebuilt from the same, now-consistent server state in one pass
     rather than being patched region by region. If nothing broke, a
     light region resync is still enough since Liquid already renders the
     correct state. */
  function checkoutReturnResync(){
    reconcileOnce().then(function(changed){
      if(changed){location.reload();return;}
      refreshRegions().catch(function(){});
    }).catch(function(){});
  }

  document.addEventListener('click',function(e){var b=e.target.closest&&e.target.closest('[data-idrak-add],[data-nf2-system-add]');if(b&&!b.disabled){var sys=makeSystem(b);if(sys){e.preventDefault();e.stopPropagation();e.stopImmediatePropagation();add(b,sys);return;}}var rm=e.target.closest&&e.target.closest('[data-idrak-remove-system]');if(rm){e.preventDefault();e.stopPropagation();removeSystem(rm.dataset.idrakSystemInstance,!!rm.closest('#main-cart-items'));}},true);
  document.addEventListener('DOMContentLoaded',schedule);
  window.addEventListener('pageshow',checkoutReturnResync);
  new MutationObserver(function(ms){if(ms.some(function(m){return Array.from(m.addedNodes||[]).some(function(n){return n.nodeType===1&&(n.matches&&n.matches('#CartDrawer-CartItems,#main-cart-items,.cart-item')||n.querySelector&&n.querySelector('.cart-item'));});}))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
})();

/* IDRAK cart-drawer conversion cleanup — staging 2026-09-02
   Keep PDP/System merchandising intact; suppress the generic Selleasy in-cart recommendation
   that collides with the curated System drawer on mobile. */
(function(){
  if(window.__idrakCartDrawerMerchCleanupV1) return;
  window.__idrakCartDrawerMerchCleanupV1=true;

  var HEADING='complete your stack & save more';
  var SUBHEADING='boost your results with these recommended additions';
  var timer=null;

  function norm(v){return String(v||'').replace(/\s+/g,' ').trim().toLowerCase();}
  function isProtected(node){
    if(!node||!node.matches)return true;
    return node.matches('cart-drawer,cart-drawer-items,#CartDrawer-CartItems,.drawer__inner,.drawer__contents,.drawer__inner-empty,[id^="CartDrawer-Item-"],.cart-item,.idrak-system-line') || !!node.querySelector('[id^="CartDrawer-Item-"],.idrak-system-line');
  }
  function appish(node){
    var meta=((node.id||'')+' '+(typeof node.className==='string'?node.className:'')+' '+node.tagName).toLowerCase();
    return /selleasy|upsell|cross.?sell|logbase|lb-/.test(meta);
  }
  function hasAdd(node){
    return Array.from(node.querySelectorAll('button,a')).some(function(el){return norm(el.textContent)==='add';});
  }
  function findSignal(drawer){
    return Array.from(drawer.querySelectorAll('h1,h2,h3,h4,h5,h6,p,div,span,strong')).find(function(el){
      var t=norm(el.textContent);
      return t===HEADING||t===SUBHEADING;
    })||null;
  }
  function findWidget(drawer,signal){
    var node=signal,candidate=null;
    while(node&&node!==drawer){
      if(isProtected(node)) break;
      var text=norm(node.textContent),hasHeading=text.indexOf(HEADING)!==-1,hasSub=text.indexOf(SUBHEADING)!==-1;
      if((hasHeading&&hasSub&&hasAdd(node))||(appish(node)&&(hasHeading||hasSub))){
        candidate=node;
        if(appish(node)&&hasAdd(node)) break;
      }
      node=node.parentElement;
    }
    return candidate;
  }
  function suppress(){
    var drawer=document.querySelector('cart-drawer');
    if(!drawer)return;
    var signal=findSignal(drawer);
    if(!signal)return;
    var widget=findWidget(drawer,signal);
    if(!widget||isProtected(widget))return;
    widget.setAttribute('data-idrak-selleasy-drawer-suppressed','true');
    widget.setAttribute('aria-hidden','true');
    widget.hidden=true;
    widget.style.setProperty('display','none','important');
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(suppress,30);}

  document.addEventListener('DOMContentLoaded',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('idrak:cart-opened',schedule);
  new MutationObserver(function(ms){
    if(ms.some(function(m){return Array.from(m.addedNodes||[]).some(function(n){return n.nodeType===1&&(n.closest&&n.closest('cart-drawer')||n.querySelector&&n.querySelector('cart-drawer'));});}))schedule();
  }).observe(document.documentElement,{childList:true,subtree:true});
})();